// SVG Icons for Fairdrop

export function HamburgerIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

export function CloseIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export function SparkleIcon({ className = '' }: { className?: string }) {
  // Original fairdrop-select.svg icon
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 70 70"
      fill="currentColor"
    >
      <polygon fillRule="evenodd" clipRule="evenodd" points="34.323,24.455 50.021,67.395 34.617,60.488 19.281,68.141" />
      <path d="M23.751,17.017l-7.132-7.132c-0.433-0.432-0.433-1.135,0-1.567l0.554-0.555c0.433-0.432,1.134-0.432,1.567,0l7.132,7.133c0.433,0.435,0.433,1.135,0,1.567l-0.554,0.554C24.886,17.45,24.184,17.45,23.751,17.017" />
      <path d="M20.607,26.214H10.521c-0.612,0-1.108-0.496-1.108-1.107v-0.784c0-0.612,0.496-1.108,1.108-1.108h10.087c0.612,0,1.108,0.496,1.108,1.108v0.784C21.715,25.718,21.219,26.214,20.607,26.214" />
      <path d="M35.042,13.303h-0.784c-0.612,0-1.108-0.495-1.108-1.107V2.108C33.15,1.496,33.646,1,34.258,1h0.784c0.612,0,1.108,0.496,1.108,1.108v10.087C36.15,12.808,35.654,13.303,35.042,13.303" />
      <path d="M43.982,17.017l-0.555-0.554c-0.433-0.433-0.433-1.133,0-1.567l7.133-7.133c0.433-0.432,1.135-0.432,1.568,0l0.554,0.555c0.433,0.433,0.433,1.136,0,1.567l-7.134,7.132C45.117,17.45,44.416,17.45,43.982,17.017" />
      <path d="M58.779,26.214H48.693c-0.613,0-1.108-0.496-1.108-1.107v-0.784c0-0.612,0.495-1.108,1.108-1.108h10.086c0.612,0,1.108,0.496,1.108,1.108v0.784C59.888,25.718,59.392,26.214,58.779,26.214" />
    </svg>
  );
}

export function DropArrowIcon({ className = '' }: { className?: string }) {
  // Original fairdrop-drop.svg icon
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 70 70"
      fill="currentColor"
    >
      <g>
        <path d="M26.27,53.56c2.415-0.041,4.855-0.066,7.242-0.059l-1.56,2.643l11.228-19.024l-13.162,6.497l-13.187-5.209l13.139,21.095l1.786-3.026c-1.219-0.008-2.446-0.009-3.672-0.002L26.27,53.56z" />
        <path d="M2.359,57h2.88c0,1-0.292,0.991-0.434,1.074c0.841-0.493,6.613-1.297,18.517-1.574l-1.213-2.055l-0.562-0.901C2.363,54.087,2.359,56,2.359,57z" />
        <path d="M55.339,57h2.881c0-1,0-2.823-18.879-3.405c-0.401-0.013-0.812-0.021-1.222-0.031l-1.757,2.977c0.979,0.021,1.948,0.045,2.889,0.074l0.045-1.429l-0.044,1.444c10.682,0.329,15.732,0.979,16.521,1.441C55.632,57.988,55.339,58,55.339,57z" />
        <path d="M33.512,53.501c-2.387-0.008-4.828,0.018-7.242,0.059l1.815,2.914c1.226-0.007,2.453-0.006,3.672,0.002l0.196-0.332L33.512,53.501z" />
      </g>
      <path d="M55.34,57c0,0,0.293-0.677,0.435-0.761c-1.239,0.728-10.784,1.812-25.484,1.812c-14.701,0-24.247-1.122-25.485-1.85C4.946,56.285,5.239,57,5.239,57h-2.88c0,2,1.261,2.52,9.077,3.187c5.042,0.431,11.738,0.745,18.854,0.745s13.812-0.353,18.854-0.783C56.959,59.481,58.221,59,58.221,57H55.34z" />
      <g>
        <path d="M31.789,55.061h-3V36.222c0-14.735,11.989-26.724,26.726-26.724h11.635v3H55.515c-13.082,0-23.726,10.643-23.726,23.724V55.061z" />
      </g>
    </svg>
  );
}

export function CheckIcon({ className = '', style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      className={className}
      style={style}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="32" cy="32" r="28" />
      <path d="M20 32l8 8 16-16" />
    </svg>
  );
}

export function LockIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M8 1a3 3 0 0 0-3 3v2H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-3-3zm0 1.5A1.5 1.5 0 0 1 9.5 4v2h-3V4A1.5 1.5 0 0 1 8 2.5z" />
    </svg>
  );
}

export function CopyIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <rect x="5" y="5" width="9" height="9" rx="1" />
      <path d="M3 11V3a1 1 0 0 1 1-1h8" />
    </svg>
  );
}

export function GearIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

export function BellIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

export function StampIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      {/* Ticket/coupon style stamp */}
      <path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V6z" />
      {/* Plus sign */}
      <line x1="12" y1="9" x2="12" y2="15" />
      <line x1="9" y1="12" x2="15" y2="12" />
    </svg>
  );
}

export function ForwardIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M22 2L11 13" />
      <path d="M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
  );
}

export function GithubIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fillRule="evenodd" d="M10 0C4.477 0 0 4.477 0 10c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.604-3.369-1.341-3.369-1.341-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0 1 10 4.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C17.137 18.163 20 14.418 20 10c0-5.523-4.477-10-10-10z" />
    </svg>
  );
}

export function XIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M11.903 8.596L19.36 0h-1.768l-6.478 7.467L5.955 0H0l7.821 11.29L0 20.242h1.768l6.838-7.881 5.46 7.881H20l-8.097-11.646zm-2.42 2.79l-.793-1.125L2.402 1.315h2.713l5.09 7.217.792 1.125 6.615 9.381h-2.713l-5.396-7.652z" />
    </svg>
  );
}

export function DatafundIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M7 10h6M10 7v6" strokeWidth="1.5" stroke="currentColor" />
    </svg>
  );
}

// Fairdrop Logo
export function FairdropLogo({ className = '' }: { className?: string }) {
  return (
    <svg
      className={className}
      height="24"
      viewBox="0 0 178 33"
      fill="currentColor"
    >
      <path d="M43.82,22.658l-2.048,1.916l-3.583-2.602l-4.265,2.086c-0.718,0.344-1.469,0.516-2.287,0.516c-1.194,0-2.286-0.371-3.241-1.086c-0.922-0.744-1.4-1.658-1.4-2.773c0-1.344,0.854-2.658,2.321-3.344l8.599-4.145v-0.943H27.85V9.71h13.137V20.6L43.82,22.658z M32.388,21.83l5.527-2.688v-2.943l-7.062,3.4c-0.513,0.258-0.786,0.629-0.786,1.115c0,0.715,0.751,1.287,1.536,1.287C31.91,22.002,32.149,21.943,32.388,21.83" />
      <path d="M51.737,3.937c0.819-0.687,2.116-0.687,2.901,0c0.819,0.657,0.819,1.743,0,2.429c-0.785,0.657-2.082,0.657-2.901,0C50.952,5.68,50.952,4.594,51.737,3.937 M54.74,24.002h-3.07V9.711h3.07V24.002z" />
      <path d="M68.254,24.002h-3.071V13.57l-2.935-2.23l2.048-1.915l2.082,1.6c1.159-1.258,2.695-1.887,4.605-1.887c1.604,0,2.97,0.487,4.096,1.43s1.706,2.087,1.706,3.431v0.857h-3.071v-0.857c0-1.258-1.229-2.287-2.73-2.287c-1.501,0-2.729,1.029-2.729,2.287V24.002z" />
      <path d="M102.04,3.422v20.58h-3.072v-1.4c-1.74,1.314-3.787,1.973-6.143,1.973c-2.56,0-4.71-0.742-6.518-2.258c-1.809-1.516-2.696-3.316-2.696-5.46c0-2.143,0.888-3.944,2.696-5.459c1.808-1.515,3.958-2.258,6.518-2.258c2.355,0,4.402,0.658,6.143,1.972V3.422H102.04z M98.967,16.856c0-1.399-0.613-2.629-1.809-3.629c-1.193-1.001-2.66-1.515-4.334-1.515c-1.672,0-3.14,0.514-4.334,1.515c-1.193,1-1.809,2.23-1.809,3.629c0,1.4,0.615,2.63,1.809,3.63c1.194,1.002,2.662,1.516,4.334,1.516c1.674,0,3.141-0.514,4.334-1.516C98.354,19.486,98.967,18.256,98.967,16.856" />
      <path d="M115.553,24.002h-3.072V13.57l-2.934-2.23l2.047-1.915l2.082,1.6c1.16-1.258,2.695-1.887,4.607-1.887c1.604,0,2.967,0.487,4.094,1.43s1.707,2.087,1.707,3.431v0.857h-3.07v-0.857c0-1.258-1.23-2.287-2.73-2.287c-1.502,0-2.73,1.029-2.73,2.287V24.002z" />
      <path d="M130.911,16.856c0-2.143,0.887-3.944,2.695-5.459s3.959-2.258,6.518-2.258c2.561,0,4.709,0.743,6.518,2.258s2.695,3.316,2.695,5.459c0,2.144-0.887,3.945-2.695,5.46s-3.957,2.258-6.518,2.258c-2.559,0-4.709-0.742-6.518-2.258S130.911,19,130.911,16.856 M133.981,16.856c0,1.4,0.613,2.63,1.809,3.63c1.195,1.002,2.662,1.516,4.334,1.516s3.139-0.514,4.334-1.516c1.195-1,1.809-2.23,1.809-3.63c0-1.399-0.613-2.629-1.809-3.629c-1.195-1.001-2.662-1.515-4.334-1.515s-3.139,0.514-4.334,1.515C134.594,14.227,133.981,15.457,133.981,16.856" />
      <path d="M157.528,31.148V9.711h3.072v1.4c1.738-1.314,3.787-1.972,6.141-1.972c2.561,0,4.711,0.743,6.52,2.258s2.695,3.316,2.695,5.459c0,2.144-0.887,3.945-2.695,5.46s-3.959,2.258-6.52,2.258c-2.354,0-4.402-0.658-6.141-1.973v8.547H157.528z M160.6,16.856c0,1.4,0.613,2.63,1.809,3.63c1.193,1.002,2.66,1.516,4.332,1.516s3.141-0.514,4.334-1.516c1.195-1,1.811-2.23,1.811-3.63c0-1.399-0.615-2.629-1.811-3.629c-1.193-1.001-2.662-1.515-4.334-1.515s-3.139,0.514-4.332,1.515C161.213,14.227,160.6,15.457,160.6,16.856" />
      <polygon points="19.617,9.377 19.617,12.235 5.128,12.235 5.128,24.002 2.27,24.002 2.27,1.565 19.617,1.565 19.617,4.424 5.128,4.424 5.128,9.377" />
    </svg>
  );
}
